/** Longest matching prefix wins. `null` = any authenticated admin (dashboard, change password). */
const ROUTE_RIGHTS: Array<{ prefix: string; right: string }> = [
  { prefix: "/users", right: "UserIndex" },
  { prefix: "/roles", right: "UserRole" },
  { prefix: "/members/dashboard", right: "MemberDashboard" },
  { prefix: "/members/minds", right: "MemberMinds" },
  { prefix: "/members/xinmiao", right: "MemberXinmiao" },
  { prefix: "/members", right: "MemberIndex" },
  { prefix: "/roadmap-2027", right: "MemberIndex" },
  { prefix: "/bonus/points", right: "BonusPoints" },
  { prefix: "/bonus/adjustments", right: "BonusAdjustment" },
  { prefix: "/bonus/income-tax", right: "BonusAdjustment" },
  { prefix: "/bonus/report", right: "ReportBonus" },
  { prefix: "/bonus", right: "BonusIndex" },
  { prefix: "/products", right: "ProductIndex" },
  { prefix: "/settings/product-categories", right: "ProductCategories" },
  { prefix: "/stock-in", right: "StockIndex" },
  { prefix: "/issue", right: "IssueIndex" },
  { prefix: "/loan-out", right: "LoanOutIndex" },
  { prefix: "/loan-in", right: "LoanInIndex" },
  { prefix: "/goods-return", right: "GoodsReturnIndex" },
  { prefix: "/credit-note", right: "CreditNoteIndex" },
  { prefix: "/write-off", right: "WriteOffIndex" },
  { prefix: "/branch", right: "BranchInvoiceIndex" },
  { prefix: "/transfer", right: "TransferIndex" },
  { prefix: "/adjustment", right: "AdjustmentIndex" },
  { prefix: "/invoices-cancel", right: "InvoiceCancelIndex" },
  { prefix: "/invoices-pending", right: "InvoicePendingIndex" },
  { prefix: "/invoices-reject", right: "InvoiceRejectIndex" },
  { prefix: "/invoices-einvoice", right: "InvoiceEinvoice" },
  { prefix: "/xmegami-picks", right: "InvoiceXmegamiPicks" },
  { prefix: "/invoices", right: "InvoiceIndex" },
  { prefix: "/self-pickup", right: "SelfPickupIndex" },
  { prefix: "/consignment", right: "ConsignmentIndex" },
  { prefix: "/barcodes", right: "BarcodeIndex" },
  { prefix: "/vouchers", right: "VoucherIndex" },
  { prefix: "/checkout-campaigns", right: "CheckoutCampaignIndex" },
  { prefix: "/campaigns/rising-star-leader-rewards", right: "RisingStarLeaderRewardIndex" },
  { prefix: "/campaigns/birthday", right: "SettingsBirthdayGift" },
  { prefix: "/campaigns/special-addon", right: "CampaignSpecialAddon" },
  { prefix: "/lucky-draw", right: "LuckyDrawIndex" },
  { prefix: "/reports/sales-account", right: "ReportSales" },
  { prefix: "/reports/sales", right: "ReportSales" },
  { prefix: "/reports/cp58", right: "ReportCp58" },
  { prefix: "/reports/ajl", right: "ReportAjl" },
  { prefix: "/tickets/solved", right: "TicketSolved" },
  { prefix: "/tickets", right: "TicketIndex" },
  { prefix: "/customer-voice", right: "CustomerVoiceIndex" },
  { prefix: "/training", right: "TrainingIndex" },
  { prefix: "/ai/knowledge", right: "AIKnowledge" },
  { prefix: "/ai/chat-logs", right: "AIChatLogs" },
  { prefix: "/settings/notices", right: "NoticeIndex" },
  { prefix: "/settings/banks", right: "SettingsBanks" },
  { prefix: "/settings/suppliers", right: "SettingsSuppliers" },
  { prefix: "/settings/countries", right: "SettingsCountries" },
  { prefix: "/settings/states", right: "SettingsStates" },
  { prefix: "/settings/delivery-charges", right: "SettingsDeliveryCharges" },
  { prefix: "/settings/payment-modes", right: "SettingsPaymentModes" },
  { prefix: "/settings/website-content", right: "SettingsWebsiteContent" },
  { prefix: "/settings/app-settings", right: "SettingsAppSettings" },
  { prefix: "/settings/portal-tool-links", right: "SettingsPortalToolLinks" },
  { prefix: "/settings/push-notifications", right: "SettingsPushNotifications" },
  { prefix: "/settings/maintenance", right: "SettingsMaintenance" },
];

export function requiredRightForPath(pathname: string): string | null {
  const path = (pathname.split("?")[0] ?? pathname).replace(/\/$/, "") || "/";
  let best: { prefix: string; right: string } | undefined;
  for (const rule of ROUTE_RIGHTS) {
    if (path === rule.prefix || path.startsWith(`${rule.prefix}/`)) {
      if (!best || rule.prefix.length > best.prefix.length) best = rule;
    }
  }
  return best?.right ?? null;
}
